import { Currency } from './ap-document/ap-document';

/**
 * Which conversions the bank is expected to perform (#5145).
 *
 * **A mirror, not the authority.** The real list is `Finance:AllowedCurrencyPairs` in the API's
 * configuration, and `CurrencyPairPolicy` enforces it — this copy exists only so a picker can offer
 * workable choices instead of letting someone select one and then be refused on save. If the two ever
 * disagree, the API wins and the worst outcome is a choice this list hides or a rejection it did not
 * predict.
 *
 * **It is a business guardrail, not a correctness mechanism.** With per-line rates an unlisted pair would
 * post perfectly correctly; it is only operationally implausible. Everything routes through USD, mirroring
 * the rate table's own pivot — HNL ↔ EUR is absent on purpose, not by oversight.
 */
const ALLOWED_PAIRS: ReadonlySet<string> = new Set([
  `${Currency.USD}>${Currency.HNL}`,
  `${Currency.USD}>${Currency.EUR}`,
  `${Currency.HNL}>${Currency.USD}`,
  `${Currency.EUR}>${Currency.USD}`,
]);

/** Whether money may move from one currency to the other in a single transfer. Same currency is not a
 *  conversion and is always allowed. */
export function isConvertible(from: Currency, to: Currency): boolean {
  return from === to || ALLOWED_PAIRS.has(`${from}>${to}`);
}
